import { render } from "./AmisFooter.vue?vue&type=template&id=635f1430&scoped=true"
import script from "./AmisFooter.vue?vue&type=script&lang=js"
export * from "./AmisFooter.vue?vue&type=script&lang=js"

import "./AmisFooter.vue?vue&type=style&index=0&id=635f1430&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635f1430"]])

export default __exports__